var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLocation = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9870679,13 C21.7356474,17.8487018 17.8487018,21.7356474 13,21.9870679 L13,23.5 C13,23.7761424 12.7761424,24 12.5,24 C12.2238576,24 12,23.7761424 12,23.5 L12,21.9870679 C7.15129822,21.7356474 3.26435264,17.8487018 3.01293206,13 L1.5,13 C1.22385763,13 1,12.7761424 1,12.5 C1,12.2238576 1.22385763,12 1.5,12 L3.01293206,12 C3.26435264,7.15129822 7.15129822,3.26435264 12,3.01293206 L12,1.5 C12,1.22385763 12.2238576,1 12.5,1 C12.7761424,1 13,1.22385763 13,1.5 L13,3.01293206 C17.8487018,3.26435264 21.7356474,7.15129822 21.9870679,12 L23.5,12 C23.7761424,12 24,12.2238576 24,12.5 C24,12.7761424 23.7761424,13 23.5,13 L21.9870679,13 L21.9870679,13 Z M12.5,21 C17.1944204,21 21,17.1944204 21,12.5 C21,7.80557963 17.1944204,4 12.5,4 C7.80557963,4 4,7.80557963 4,12.5 C4,17.1944204 7.80557963,21 12.5,21 Z M12.5,17 C10.0147186,17 8,14.9852814 8,12.5 C8,10.0147186 10.0147186,8 12.5,8 C14.9852814,8 17,10.0147186 17,12.5 C17,14.9852814 14.9852814,17 12.5,17 Z M12.5,16 C14.4329966,16 16,14.4329966 16,12.5 C16,10.5670034 14.4329966,9 12.5,9 C10.5670034,9 9,10.5670034 9,12.5 C9,14.4329966 10.5670034,16 12.5,16 Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLocation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/location.4a2a323c17eb8775b7f5821cbc0ea8ce.svg";